import { isString } from 'lodash'
import moment from 'moment'

/**
 * YYYY-MM-DD
 */
export type DateOnlyString = string

/**
 * ISO DateTime
 */
export type DateTimeString = string

const DateOnlyPattern = /^\d{4}-\d{2}-\d{2}$/
const ISOPattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/

export function isISODateString(value: any): value is DateOnlyString | DateTimeString {
  return isString(value) && (DateOnlyPattern.test(value) || ISOPattern.test(value))
}

/**
 * Calculates calendar-day difference between a date and today.
 * Returns whole numbers: 0 for today, positive for future, negative for past.
 * Uses startOf('day') in local time on both sides to ignore time-of-day.
 */
export function calculateDaysOut(date: string | moment.Moment): number {
  const target = moment.isMoment(date) ? date.clone().local().startOf('day') : moment(date).startOf('day')
  return target.diff(moment().startOf('day'), 'days')
}
